<script setup>
import { ref, computed } from 'vue';
import WhatsappTemplatePreview from './Create/WhatsappTemplatePreview.vue';
import { whatsappTemplateParser } from 'dashboard/helper/whatsappTemplateParser';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  template: { type: Object, required: true },
});

defineEmits(['delete']);

const showPreviewModal = ref(false);

const parsedData = computed(() => whatsappTemplateParser(props.template));

const previewHeader = computed(() => {
  const { template, sampleValues } = parsedData.value;
  if (template.header === 'TEXT') {
    let text = template.headerText || '';
    const userValue = sampleValues.headerValues[1];
    if (userValue && userValue.trim()) text = text.replace('{{1}}', userValue);
    return text;
  }
  return null;
});

const previewBodyWithHighlight = computed(() => {
  const { template, sampleValues } = parsedData.value;
  let text = template.body || '';
  if (!text) return '';

  Object.keys(sampleValues.bodyValues).forEach(varNum => {
    const userValue = sampleValues.bodyValues[varNum];
    const hasValue = userValue && userValue.trim();
    const displayValue = hasValue ? userValue : `{{${varNum}}}`;
    const replacement = hasValue
      ? `<span class="bg-green-700 text-white px-1 py-[1px] rounded">${displayValue}</span>`
      : `<span>{{${varNum}}}</span>`;
    text = text.replace(new RegExp(`\\{\\{${varNum}\\}\\}`, 'g'), replacement);
  });

  return text.replace(/\n/g, '<br>');
});
</script>

<template>
  <tr>
    <td class="py-4 ltr:pr-4 rtl:pl-4">{{ template.name }}</td>
    <td class="py-4 ltr:pr-4 rtl:pl-4">
      <span
        class="py-1 px-4 rounded-lg capitalize"
        :class="{
          'bg-green-100 text-green-500': template.status === 'APPROVED',
          'bg-red-100 text-red-500': template.status === 'REJECTED',
          'bg-slate-100 text-slate-500': !['APPROVED', 'REJECTED'].includes(
            template.status
          ),
        }"
      >
        {{ template.status }}
      </span>
    </td>
    <td class="py-4 ltr:pr-4 rtl:pl-4">{{ template.category }}</td>
    <td class="py-4 ltr:pr-4 rtl:pl-4">{{ template.language }}</td>
    <td class="py-4">
      <div class="flex gap-1 justify-center flex-shrink-0">
        <Button
          v-tooltip.top="$t('WHATSAPP_TEMPLATES.LIST.PREVIEW')"
          icon="i-lucide-eye"
          color="slate"
          size="sm"
          ghost
          @click="showPreviewModal = true"
        />
        <Button
          icon="i-lucide-trash-2"
          color="ruby"
          size="sm"
          ghost
          @click="$emit('delete', template)"
        />
      </div>
      <woot-modal
        :show="showPreviewModal"
        :on-close="() => (showPreviewModal = false)"
      >
        <div class="p-8">
          <WhatsappTemplatePreview
            :template="parsedData.template"
            :preview-header="previewHeader"
            :preview-body-with-highlight="previewBodyWithHighlight"
          />
        </div>
      </woot-modal>
    </td>
  </tr>
</template>
